export const getQueryParam = (key: string) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(key);
}

export const deleteQueryParams = (keys: string | string[]) => {
  const normalizedKeys = Array.isArray(keys) ? keys : [keys];
  const url = new URL(window.location.href);
  for (const key of normalizedKeys) url.searchParams.delete(key);
  window.history.replaceState(window.history.state, '', url.href);
}

export const clearQueryParams = () => {
  const url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState(window.history.state, '', url.href);
}

export const setQueryParam = (data: { [key: string]: string | number }) => {
  const url = new URL(window.location.href);
  for (const [key, val] of Object.entries(data)) {
    url.searchParams.set(key, String(val));
    if (val === '') url.searchParams.delete(key);
  }

  window.history.replaceState(window.history.state, '', url.href);
}